import { createFileRoute } from "@tanstack/react-router"
import { BlueprintSearchPage } from "@/features/blueprint-search/components/BlueprintSearchPage"

export const Route = createFileRoute("/(authenticated)/search")({
  component: BlueprintSearchPage,
})
